import OMT_UI_SquareButton, { BUTTONCOLOURS } from '../../OMT_UI/OMT_UI_SquareButton';

export default class CoinShopSpinBtn extends OMT_UI_SquareButton {
  constructor(x, y, config) {
    super(x, y, config);

    this.refreshState();
    this.bindings = [
      G.sb('onFreeMoneySpinUsed').add(this.refreshState, this),
    ];
  }

  _drawButton() {
    this.iconGroup = new Phaser.Group(game, this);
    this.icon = G.makeImage(0, 0, 'new_wheel_menu', 0.5, this.iconGroup);
    this.videoIcon = G.makeImage(0, 0, 'video_wheel_menu', 0.5, this.iconGroup);
    this.videoIcon.x = this.icon.x + (this.icon.width - this.videoIcon.width) / 2;
    this.videoIcon.y = this.icon.y + (this.icon.height - this.videoIcon.width) / 2;
    this.videoIcon.visible = false;
    this.iconGroup.scale.setTo(0.8);
    this.config.text.icon = {
      image: this.iconGroup,
      align: 'left',
      offset: {
        x: this.iconGroup.width / 4,
        y: 0,
      },
    };
    this.config.text.offset.x = this.iconGroup.width / 8;
    super._drawButton();
  }

  destroy() {
    this.bindings.forEach((binding) => {
      binding.detach();
    });
    super.destroy();
  }

  refreshState() {
    if (this.game === null) return;
    const prev = this.spinState;
    const current = G.saveState.isFreeMoneySpinAvailable() && G.featureUnlock.freeFailFlowWheelSpin;

    if (current !== prev) {
      if (current) {
        this.setColour(BUTTONCOLOURS.orange);
        this.setText(OMT.language.getText('Free Spin'));
        this.resize(309, 100);
        this.videoIcon.visible = false;
      } else if (game.incentivised()) {
        this.setColour(BUTTONCOLOURS.purple);
        this.setText(OMT.language.getText('Spin Wheel'));
        this.resize(309, 100);
        this.videoIcon.visible = true;
      } else {
        this.setColour(BUTTONCOLOURS.gray);
        this.setText(OMT.language.getText('Free Spin'));
        this.resize(309, 100);
        this.videoIcon.visible = false;
      }
    }
    this.spinState = current;
  }
}
